import _ from 'lodash';
import React from 'react';

import Table from 'components/Table';
import Button from 'components/Button';
import StatusBox from 'components/StatusBox';
import BooleanIcon from 'components/BooleanIcon';

import {EmptyListPlaceholder} from 'containers/BookingSetDetail/components';

import './styles.css';

interface RoomChecksProps {
  roomNumber: string;
  roomType: string;
  existingDamages: boolean;
  status: string;
  hasInventory: boolean;
  hasImages: boolean;
}

interface ArrivalRoomChecksTableProps {
  roomChecks: Array<RoomChecksProps>;
  openAddArrivalRoomCheckModal: () => any;
  openArrivalRoomCheckDetailModal: ({roomCheckId: number}) => any;
}

const STATUS_TO_COLOR_MAPPER = {
  Pending: StatusBox.ORANGE,
  Completed: StatusBox.GREEN
};

const RoomCheckRow = ({roomCheck, openArrivalRoomCheckDetailModal}) => (
  <Table.Row
    onClick={() =>
      openArrivalRoomCheckDetailModal({roomCheckId: roomCheck.id})
    }>
    <Table.Cell className="room">
      <div>{roomCheck.roomNumber}</div>
    </Table.Cell>
    <Table.Cell className="roomType">
      <div>{roomCheck.roomType}</div>
    </Table.Cell>
    <Table.Cell className="inventory">
      <BooleanIcon value={roomCheck.hasInventory} />
    </Table.Cell>
    <Table.Cell className="images">
      <BooleanIcon value={roomCheck.hasImages} />
    </Table.Cell>
    <Table.Cell className="existingDamages">
      <div>{roomCheck.existingDamages ? 'Yes' : 'No'}</div>
    </Table.Cell>
    <Table.Cell className="description">
      <div className="textContainer">{roomCheck.description}</div>
    </Table.Cell>
    <Table.Cell className="status">
      <div>
        <StatusBox
          status={roomCheck.status}
          color={STATUS_TO_COLOR_MAPPER[roomCheck.status]}
        />
      </div>
    </Table.Cell>
  </Table.Row>
);

class ArrivalRoomChecksTable extends React.Component<
  ArrivalRoomChecksTableProps
> {
  render() {
    const {
      roomChecks,
      openAddArrivalRoomCheckModal,
      openArrivalRoomCheckDetailModal
    } = this.props;

    return (
      <div className="ArrivalRoomChecksTable">
        <Table className="ArrivalRoomChecksTable__table">
          <Table.Header>
            <Table.HeaderItem heading="Room no" className="room" />
            <Table.HeaderItem heading="Room type" className="roomType" />
            <Table.HeaderItem heading="Inventory" className="inventory" />
            <Table.HeaderItem heading="Images" className="images" />
            <Table.HeaderItem
              heading="Existing damages"
              className="existingDamages"
            />
            <Table.HeaderItem heading="Description" className="description" />
            <Table.HeaderItem heading="Status" className="status" />
          </Table.Header>
        </Table>
        {_.isEmpty(roomChecks) && <EmptyListPlaceholder />}
        {!_.isEmpty(roomChecks) && (
          <Table>
            <Table.Body className="ArrivalRoomChecksTable__tableBody">
              {roomChecks.map((roomCheck, index) => (
                <RoomCheckRow
                  key={index}
                  roomCheck={roomCheck}
                  openArrivalRoomCheckDetailModal={
                    openArrivalRoomCheckDetailModal
                  }
                />
              ))}
            </Table.Body>
          </Table>
        )}
        <div className="ArrivalRoomChecksTable__footer">
          <Button blue onClick={openAddArrivalRoomCheckModal}>
            Add
          </Button>
        </div>
      </div>
    );
  }
}

export default ArrivalRoomChecksTable;
